import React from 'react';
import PropTypes from 'prop-types';

import { ToggleBtn } from "../Inputs";

// styles
import './ToggleMap.css';
// 'Switch to box view' : 'Switch to map view'
const ToggleMap = ({ onToggle, isMapTop, customClass }) => {
    return (
        <div className={`toggle-map-row rtl ${customClass}`}>
            <ToggleBtn
                toggle={() => onToggle()}
                isChecked={isMapTop}
            />
            <label className="toggle-map-top-text">
                {isMapTop ? 'שנה לרשימה' : 'שנה למפה'}
            </label>
        </div>
    )
};

ToggleMap.propTypes = {
    onToggle: PropTypes.func,
    isMapTop: PropTypes.bool,
    customClass: PropTypes.string
};

export default ToggleMap;



// WEBPACK FOOTER //
// ./src/Components/Elements/Toggles/ToggleMap.js